// extracted by mini-css-extract-plugin
export default {"WorkingWithTic":"WorkingWithTIC_WorkingWithTic__y1e1Y"};